/* Import Leverege Modules */
import ModelUtil from '@leverege/model-util';

/* Import Local Modules */
import Util from "./Util.js";
/**
 * Creates a formatter with a configured type.
 */
function create() {
  return {
    type: Util.getFormatterTypeForType('geoPoint'),
    format: '-d',
    decimalPlaces: 6,
    singleLine: true,
    latPrefix: null,
    lonPrefix: null
  };
}

/* Export Module */
export default {
  TYPE: Util.getFormatterTypeForType('geoPoint'),
  create,
  ...ModelUtil.createAllValue('format'),
  ...ModelUtil.createAllValue('decimalPlaces'),
  ...ModelUtil.createAllValue('singleLine'),
  ...ModelUtil.createAllValue('latPrefix'),
  ...ModelUtil.createAllValue('lonPrefix')
};